import { isFeatureEnabled } from '../../config';
import { AuditLogLegacy, IAuditLogProps } from './AuditLogLegacy';
import { AuditLogV2 } from './AuditLogV2';

// New table is default; UseOldAuditLog restores the legacy list/detail view.
export const AuditLog = isFeatureEnabled('UseOldAuditLog') ? AuditLogLegacy : AuditLogV2;

export type { IAuditLogProps };
